import { ReactNode } from 'react';
import { mixpanelTrackEvent } from '@/lib/mixpanel';

export const EditProfileButton = ({
  children,
  className,
  url,
  dataTestId,
  mixpanelEvent,
}: {
  children: ReactNode;
  className: string;
  url: string;
  dataTestId?: string;
  mixpanelEvent?: string;
}) => (
  <button
    type="button"
    className={className}
    data-testid={dataTestId}
    onClick={() => {
      window.open(url, '_blank');
      mixpanelTrackEvent('EcommerceEdit', {
        type: mixpanelEvent,
      });
    }}
  >
    {children}
  </button>
);
